// extracted by mini-css-extract-plugin
export default {"PinConfirm":"PinConfirm_PinConfirm__H3aLF","PinConfirmInner":"PinConfirm_PinConfirmInner__pzqM2","Title":"PinConfirm_Title__n36vF","SubTitle":"PinConfirm_SubTitle__21RLA"};